import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { EYE_ICON, EYE_SLASH_ICON } from 'assets/constants/Icons';
import { TYPE_SUCCESS, INTERVAL, TYPE_FAIL, passwordMatchPattern, TYPE_INFO, SECRET_KEY } from "assets/constants/Constants";
import ShowToast from 'components/ShowToast';
import CryptoJS from "crypto-js";
import md5 from 'md5';
import { resetPasswordByAdminCall } from "lib/axiosUtils";

Modal.setAppElement('#root')
function ResetPasswordComponent(props) {
    const [isModalOpen, setModalOpen] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState({});
    const [resetButtonLoading, setResetButtonLoading] = useState(false);

    useEffect(() => {
        setModalOpen(props.modelOpen);
    }, [props]);

    const closeModal = () => {
        setModalOpen(false);
        props.cancelHandle();
    }

    const cancelHandle = (event) => {
        setModalOpen(false);
        props.closeModel();
    }

    const changeNewPasswordhandler = (event) => {
        setNewPassword(event.target.value)
    }

    const changeConfirmPasswordhandler = (event) => {
        setConfirmPassword(event.target.value)
    }

    const passwordViewHandler = (event) => {
        setShowPassword(!showPassword);
    }

    const confirmPasswordViewHandler = (event) => {
        setShowConfirmPassword(!showConfirmPassword);
    }

    const resetPasswordHandler = async (event) => {
        event.preventDefault();
        try {
            if (isFormValid()) {
                setResetButtonLoading(true);
                const resetParams = {
                    password: md5(newPassword),
                    displayPassword: CryptoJS.AES.encrypt(newPassword, SECRET_KEY).toString(),
                    userId: props && props.userData ? props.userData.userId : null
                }
                if (resetParams.userId) {
                    const resetPasswordResult = await resetPasswordByAdminCall({}, resetParams);
                    if (resetPasswordResult && resetPasswordResult.data && Object.entries(resetPasswordResult.data.result).length !== 0) {
                        ShowToast('Password changed successfully', TYPE_SUCCESS, INTERVAL, null, "");
                        window.location.reload();
                    }
                    else {
                        ShowToast('Error Occurred !', TYPE_FAIL, INTERVAL, null, "");
                    }
                }
                setResetButtonLoading(false);
                setModalOpen(false);
                props.cancelHandle();
            }
        }
        catch (error) {
            console.log("Error occurred while reseting the password", error);
            setResetButtonLoading(false);
        }
    }

    const isFormValid = () => {
        let isValid = true;
        let error = {};
        if (!newPassword) {
            isValid = false;
            error.newPassword = "Please enter new password";
        }
        if (!confirmPassword) {
            isValid = false;
            error.confirmPassword = "Please enter confirm password";
        }
        if (newPassword && confirmPassword) {
            if (newPassword !== confirmPassword) {
                isValid = false;
                error.confirmPassword = "Confirm password and password do not match";
            }
        }
        if (newPassword) {
            if (!passwordMatchPattern.test(newPassword)) {
                isValid = false;
                error.newPassword = "Please enter valid new password";
                ShowToast('Password must be minimum eight characters including one uppercase letter,\n one special character and alphanumeric characters', TYPE_INFO, INTERVAL, null, "");
            }
        }
        setError(error)
        return isValid;
    }

    return (
        <>
            <Modal isOpen={isModalOpen} onRequestClose={closeModal} className="program-modal" overlayClassName="program-modal-overlay" style={{
                overlay: {
                zIndex: 1300,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                },
                content: {
                zIndex: 1301,
                }
                }}
            >
                <div className="program-modal-container job-disabled-width partner-modal-div program-modal-div display-flex-column-div padding-20px" role="document">
                    <form action="" className="display-flex-column-div">
                        <h4 className="import-error-heading text-color-black text-align-center">RESET USER PASSWORD</h4>
                        <hr></hr>
                        {<div className="display-flex-column-div mt-5" style={{ paddingLeft: '24%' }}>
                            <label className="form-label">User Name : {props ? props.userData.username : ""}</label>
                            <label className="form-label" style={{marginBottom:'-5px'}}>New Password <span className="text-danger">*</span></label>
                            <div className="input_box reset-password-input-box display-flex-column-div"
                                style={{ position: 'relative', width: '70%' }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="newPassword"
                                    className="reset-password-modal-input"
                                    value={newPassword}
                                    placeholder="Please enter new password"
                                    onChange={changeNewPasswordhandler}
                                    style={{ paddingRight: '40px', width: '100%'}}
                                />
                                <i
                                    title={showPassword ? "Hide Password" : "Show Password"}
                                    className={`${showPassword ? EYE_ICON : EYE_SLASH_ICON }`}
                                    onClick={passwordViewHandler}
                                    style={{position: 'absolute',right: '12px',top: '50%',transform: 'translateY(-50%)',cursor: 'pointer'}}
                                />
                                <div className="text-danger error-msg">
                                    {error.newPassword}
                                </div>
                            </div>
                            <label className="form-label" style={{marginTop:'15px', marginBottom:'-5px'}}>Confirm Password <span className="text-danger">*</span></label>
                            <div className="input_box reset-password-input-box display-flex-column-div"
                                style={{ position: 'relative', width: '70%' }}>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    className="reset-password-modal-input"
                                    value={confirmPassword}
                                    placeholder="Please enter confirm password"
                                    onChange={changeConfirmPasswordhandler}
                                    style={{ paddingRight: '40px', width: '100%'}}
                                />
                                <i
                                    title={showConfirmPassword ? "Hide Password" : "Show Password"}
                                    className={`${showConfirmPassword ? EYE_ICON :  EYE_SLASH_ICON }`}
                                    onClick={confirmPasswordViewHandler}
                                    style={{position: 'absolute',right: '12px',top: '50%',transform: 'translateY(-50%)',cursor: 'pointer'}}
                                />
                                <div className="text-danger error-msg">
                                    {error.confirmPassword}
                                </div>
                            </div>
                        </div>}
                        <br />
                    </form>
                    <div className="form-button-div mt-3">
                        {
                            resetButtonLoading === true ? (<>
                                <div className="spinner-loader">
                                </div>
                            </>) : (
                                <button className="brand-button" onClick={resetPasswordHandler}>Reset</button>
                            )
                        }
                        <button className="cancel_button ml-5" onClick={cancelHandle}>Cancel</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}
export default ResetPasswordComponent;